<template>
    <v-dialog v-model="dialogus" width="700" persistent>
        <v-card class="elevation-0" style="width: 100% position:relative; border-radius:10px;" >
            <v-card-title primary-title class="layout justify-center" style="text-align: left; position:relative; ">
            <v-icon style="position:absolute; top:0.5em; right:0.5em;" @click="closedialog()">close</v-icon>
            <div class="headline CSChatThai">{{$t('Homepage.Dialog.titleSendMessage')}}</div>
            </v-card-title>
            <v-container>
                <v-text-field
                  :label="$t('Homepage.Dialog.name')"
                  v-model="name"
                  single-line
                  solo
                  required
                  class="InputEdit"
                  ></v-text-field>
                <v-text-field
                  :label="$t('Homepage.Dialog.email')"
                  v-model="email"
                  :rules="emailRules"
                  single-line
                  solo
                  required
                  class="InputEdit"
                  ></v-text-field>
                <v-text-field
                  :label="$t('Homepage.Dialog.phone')"
                  v-model="phone"
                  mask="###-###-####"
                  :rules="phoneRules"
                  required
                  single-line
                  solo
                  class="InputEdit"
                ></v-text-field>
                <div  style="width: 100%;">
                <v-menu bottom offset-y style="width: 100%;height: 45px;" class="InputEdit">
                  <v-btn  flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0; font-size: 14px;">
                    <p class="CSChatThai" style="padding-left: 10px; font: 14px;color: #757575; text-transform: none;" v-if="!title.category_TH">{{$t('Settings.feedback.title')}}</p>
                    <p class="CSChatThai" style="padding-left: 10px; font: 14px;color: black; text-transform: none;" v-else>{{($i18n.locale == 'th')? title.category_TH:title.category_ENG }}</p>
                    <v-spacer></v-spacer>
                    <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
                  </v-btn>
                  <div style="background: white;height: 300px;">
                  <b style="padding: 5px !important;font-size: 15px;color: white;background: #2562af;" class="CSChatThai">{{$t('Settings.feedback.report')}} ::</b>
                  <v-list>
                    <v-list-tile v-for="(item, index) in items.list_report"  @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" style="font-size: 14px; text-transform: none;">{{($i18n.locale == 'th')? item.category_TH:item.category_ENG }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>

                  <div style="background: white;">
                 <!--  <b style="padding: 5px !important;font-size: 15px;color: #2662af;" class="CSChatThai" >ข้อเสนอแนะ</b> -->
                  <b style="padding: 5px !important;font-size: 15px;color: white;background: #2562af;" class="CSChatThai" >{{$t('Settings.feedback.suggestion')}} ::</b>
                  <v-list >
                    <v-list-tile v-for="(item, index) in items.list_feedback"  @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" style="font-size: 14px; text-transform: none;">{{($i18n.locale == 'th')? item.category_TH:item.category_ENG}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
                </div>
                </v-menu>
              </div>
                <v-textarea
          v-model="detail"
          :placeholder="$t('Settings.feedback.detail')"
          counter
          maxlength="255"
          full-width
          class="InputEdit"
          style="height: 120px;resize: none; margin-bottom: 15px;"
                ></v-textarea>
            <form ref="fileform" style="display:flex; justify-content:center; margin-left:">
            <v-flex xs12 sm12 md12 xl12  style="" class="containers hidden-sm-and-down listfile">
                <!-- <form ref="fileform"> -->
                <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 10px;" v-if="key < 5">
                  <a class="close-classic" @click="removeFile( key )"></a>
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;padding-top: 15px;">
                    <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 30px !important; width:30px !important;display: flex;justify-content: center;    margin-left: 20px;" />
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                  <div v-else style="text-align: center; display: grid; justify-content: center;" >
                    <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                </div>


                 <!-- <form ref="fileform"> -->
                <div  :style="borderinputfile" @click="uppic()" v-if="files.length < 5">

            <v-icon style="color: #757575; justify-content: center; align-items: center; display: flex;">mdi-plus-circle</v-icon>
                  <p style="color: #757575; text-align: center;">
                    {{$t('AnswerQuestion.uploadPhoto')}}
                  </p>
            <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>

                </div>

              </v-flex>
            </form>
            </v-container>
              <v-layout row wrap align-center justify-center style="padding-bottom: 20px;">
                <v-btn style="text-transform: none;" dark color="blue" :loading="loading" @click="sendfeedback()" v-if="name !== '' && email !== '' && title.category_TH && detail !== ''">
                  <span>{{$t('AnswerQuestion.sendme')}}</span>
                </v-btn>
                <v-btn disabled v-else style="text-transform: none;">
                  <span>{{$t('AnswerQuestion.sendme')}}</span>
                </v-btn>
                <v-btn dark style="color: white !important; background: gray; text-transform: none;"  @click="clear()">
                  <span>{{$t('AnswerQuestion.clear')}}</span>
                </v-btn>
              </v-layout>
            </v-card>
      </v-dialog>
</template>

<script>
export default {
    props:{
        dialogus: false,
    },
    data() {
      return {
        loading: false,
        dragAndDropCapable: false,
        borderinputfile: 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;',
        files: [],
        phone: '',
        name: '',
        email: '',
        title: {},
        detail: '',
        phoneRules: [
            v => (!!v && v.length === 10) || this.$t('Homepage.Dialog.inputphoneErrorDigit'),
            v => !!v || this.$t('Homepage.Dialog.inputphoneErrorNumber'),
            v => /^0[0-9]{9}/.test(v) || this.$t('Homepage.Dialog.inputphoneErrorFormat')
        ],
        emailRules: [
            v => !!v || this.$t('Homepage.Dialog.inputEmail'),
            v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || this.$t('Homepage.Dialog.inputEmailError')
        ],
        items: [],
      }
    },
    created () {
      this.getsubject()
    },
    mounted () {
      this.dragAndDropCapable = this.determineDragAndDropCapable()
      var me =this
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
          this.$refs.fileform.addEventListener(evt, function (e) {
            // console.log(evt)
            e.preventDefault()
            e.stopPropagation()
          })
        }.bind(this))
        this.$refs.fileform.addEventListener('dragover', function (e) {
          this.borderinputfile = 'border: 2px dotted #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;'
        }.bind(this))
        this.$refs.fileform.addEventListener('dragleave', function (e) {
          this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;'
        }.bind(this))
        this.$refs.fileform.addEventListener('drop', function (e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
            this.getImagePreviews()
            // if ( e.target.className == "borderfile" ) {
            this.borderinputfile = 'border: 1px solid #00000036; border-radius: 5px; width: 95px !important; height: 83px !important; position: relative; background: white;justify-content: center; margin-left: 10px; cursor: pointer;padding-top: 15px;'
            // }
          }
        }.bind(this))
      }
    },
    watch: {
      files () {
        if (this.files.length > 5) {
          this.$swal(
            '',
            this.$t('Alert.Fail.feedback.maxFiles'),
            'warning'
          )
          _.pullAt(this.files, [5])
        }
      },
      filesmo () {
        if (this.filesmo.length > 5) {
          this.$swal(
            '',
            this.$t('Alert.Fail.feedback.maxFiles'),
            'warning'
          )
          _.pullAt(this.filesmo, [5])
        }
      }
    },
    methods: {
        closedialog () {
          this.cancel()
          this.$emit('closeDialogus', false)
        },
        uppic () {
            $('#files').click()
        },
        uppicmo () {
            $('#filesmo').click()
        },
        sendfeedback () {
            var lengthfile = this.files.length
            if (lengthfile === 0) {
            let formData = new FormData()
            formData.append('phone', this.phone)
            formData.append('email', this.email)
            formData.append('comment', this.detail)
            formData.append('name', this.name)
            formData.append('category_id', this.title.category_id)
            this.loading = true
            this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            if (response.data.status === 'success') {
                // console.log(response.data)
                this.loading = false
                this.$swal('', this.$t('Alert.Success.success'), 'success')
                this.cancel()
              } else {
                this.loading = false
                this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
              }
            }).catch(err => {
              console.log(err)
              this.loading = false
              this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            })
          } else {
            this.sendfeedbackfile()
            // for (var i = 0; i < lengthfile; i++) {
            //   this.sendfeedbackfile(i)
            // }
          }
        },
        sendfeedbackmo () {
            var lengthfile = this.filesmo.length
            if (lengthfile === 0) {
            let formData = new FormData()
            formData.append('phone', this.phone)
            formData.append('email', this.email)
            formData.append('comment', this.detail)
            formData.append('name', this.name)
            formData.append('category_id', this.title.category_id)
            this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
                // console.log(response.data)
                this.$swal('', this.$t('Alert.Success.success'), 'success')
                this.cancel()
            }, () => {
                this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            })
            } else {
            this.sendfeedbackfilemo()
            // for (var i = 0; i < lengthfile; i++) {
            //   this.sendfeedbackfile(i)
            // }
            }
        },
        sendfeedbackfile () {
          let formData = new FormData()
          var lengthfile = this.files.length
          for (var i = 0; i < lengthfile; i++) {
          var file = this.files[i].file
          formData.append('file', file, file.name)
          }
          // console.log(formData)
          formData.append('phone', this.phone)
          formData.append('email', this.email)
          formData.append('comment', this.detail)
          formData.append('name', this.name)
          formData.append('category_id', this.title.category_id)
          this.loading = true
          this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            if (response.data.status === 'success') {
              // console.log(response.data)
              this.loading = false
              this.$swal('', this.$t('Alert.Success.success'), 'success')
              this.cancel()
            } else {
              this.loading = false
              this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            }
          }).catch(err => {
            console.log(err)
            this.loading = false
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          })
        },
        sendfeedbackfilemo () {
            let formData = new FormData()
            var lengthfile = this.filesmo.length
            for (var i = 0; i < lengthfile; i++) {
            var file = this.filesmo[i].file
            formData.append('file', file, file.name)
            }
            // console.log(formData)
            formData.append('phone', this.phone)
            formData.append('email', this.email)
            formData.append('comment', this.detail)
            formData.append('name', this.name)
            formData.append('category_id', this.title.category_id)
            this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            // console.log(response.data)
            this.$swal('', this.$t('Alert.Success.success'), 'success')
            this.cancel()
            }, () => {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            })
        },
        removeFile (key) {
            this.files.splice(key, 1)
            this.getImagePreviews(key)
        },
        removeFilemo (key) {
            this.filesmo.splice(key, 1)
            this.getImagePreviewsmo(key)
        },
        getImagePreviews (key) {
          for (let i = 0; i < this.files.length; i++) {
            if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
                let reader = new FileReader()
                reader.addEventListener('load', function () {
                this.$refs['preview' + parseInt(i)][0].src = reader.result
                }.bind(this), false)
                reader.readAsDataURL(this.files[i].file)
            } else {
            }
          }
        },
        getImagePreviewsmo (key) {
            for (let i = 0; i < this.filesmo.length; i++) {
            if (/\.(jpe?g|png|gif)$/i.test(this.filesmo[i].file.name)) {
                let reader = new FileReader()
                reader.addEventListener('load', function () {
                this.$refs['preview' + parseInt(i)][0].src = reader.result
                }.bind(this), false)
                reader.readAsDataURL(this.filesmo[i].file)
                // this.extension(this.files[i].name)
                // console.log(this.extension())
            } else {
                // this.$nextTick(function(){
                // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
                // });
                // console.log('mm')
            }
            }
        },
        extension (files) {
            var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
            var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
            var pdf = ['pdf']
            var file = ['ai', 'ps', 'psd']
            var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
            var presentation = ['ppt', 'pps', 'pot', 'pptx']
            var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
            var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
            var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
            if (pdf.includes(extension)) {
            return 'fas fa-file-pdf'
            } else if (archive.includes(extension)) {
            return 'fas fa-file-archive'
            } else if (spreadsheet.includes(extension)) {
            return 'fas fa-file-excel'
            } else if (presentation.includes(extension)) {
            return 'fas fa-file-powerpoint'
            } else if (word.includes(extension)) {
            return 'fas fa-file-word'
            } else if (execution.includes(extension)) {
            return 'fas fa-file-code'
            } else if (image.includes(extension)) {
            return 'fas fa-file-image'
            } else if (file.includes(extension)) {
            return 'fas fa-file'
            } else {
            return 'fas fa-file-alt'
            }
        // return extension[extension.length-1]
        },
        determineDragAndDropCapable () {
            var div = document.createElement('div')
            return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
        },
        handleFilesUpload (key) {
            let uploadedFiles = this.$refs.files.files
            for (var i = 0; i < uploadedFiles.length; i++) {
            this.files.push({file: uploadedFiles[i], status: 'waiting'})
            }
            this.getImagePreviews(key)
            document.querySelector('#files').value = ''
        },
        handleFilesUploadmo (key) {
            let uploadedFiles = this.$refs.filesmo.files
            for (var i = 0; i < uploadedFiles.length; i++) {
            this.filesmo.push({file: uploadedFiles[i], status: 'waiting'})
            }
            this.getImagePreviewsmo(key)
            document.querySelector('#filesmo').value = ''
        },
        getsubject () {
            this.axios.post(process.env.APImanage + '/getcategory').then((response) => {
            if (response.data.status === 'success') {
                // console.log(response.data)
                this.items = response.data
            }
            })
        },
        cancel () {
            this.phone = ''
            this.name = ''
            this.email = ''
            this.title = {}
            this.detail = ''
            this.files = []
            this.filesmo = []
        },
        clear () {
            if (this.name !== '' || this.email !== '' || this.title.category_TH || this.detail !== '') {
            this.$swal({
                title: this.$t('Alert.Sure'),
                text: this.$t('Alert.Clear'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('AnswerQuestion.ok'),
                cancelButtonText: this.$t('AnswerQuestion.cancel'),
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: true,
                showCloseButton: true,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.cancel()
                    // this.$emit('closeDialogus', false)
                }
            })

            }
        },
        sendme () {
            this.axios.post(process.env.APImanage + '/contactus', {name: this.name, email: this.email, title: this.title.category_TH, detail: this.detail, platform: 'webportal'}).then((response) => {
            if (response.data.status === 'success') {
                this.$swal(
                '',
                this.$t('Alert.Success.success'),
                'success')
                this.cancel()
            }
            }, (response) => {})
        },
        linkAPI () {
            window.open('/docs', '_blank').focus()
        },
        toPage (page) {
            this.$router.push(page)
        },
        linkregister () {
            window.open('/register').focus()
        },
        linkdownload () {
            window.open('/download').focus()
        },
        toNewTab () {
            window.open(this.webdev, '_blank').focus()
        }
    }
}
</script>

<style type="text/css" scoped>
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
}
.layoutimagemo {
  overflow-x: scroll;
  overflow-y: hidden;
  height: 195px !important;
  max-width: 100% !important;
  display: -webkit-inline-box;
  background: rgb(234, 234, 234);
  padding-top: 3px; background: rgb(255, 255, 255);
  padding-top: 3px;
  border-style: solid;
  border-width: thin;
  border-radius: 10px;
  border-color: #e5e9eb;
}
.previewimgmobile {
  text-align: center;
  display: grid;
  justify-content: center;
  border-style: solid;
  border-width: thin;
  border-radius: 10px;
  width: 140px;
  border-color: #2562af;
  background-color: white;
}
.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}
[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
[class*='closemo-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  /* position: absolute; */
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.closemo-classic-mobile:after {
  content: '×'; /* ANSI X letter */
  color: #777;
  font: 14px/100% arial, sans-serif;
  /* position: absolute; */
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.containers {
  width: 576px; margin: 0 auto;
}
.containers:after {
  content: '';
  display: block;
  clear: both;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 95px !important;
  height: 83px !important;
  position: relative;
  background: white;
}


.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--full-width.v-input {
    padding: 0;
    padding-left: 12px !important;
}
/*>>>.v-text-field.v-text-field--enclosed {
  margin: 0;
  width: 100%;
  padding: 0;
}
>>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea, .v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 25px;
  margin-top: 0;
  width: 100%;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  padding: 0;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none;
}
>>>.v-input__slot {
  border-width: thin;
  border-style: solid;
  border-color: #d2d8dd;
  border-radius: 4px;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.btnsendfeed {
  width: 100%;
  color: white;
  border-radius: 5px;
}
a:link {
    text-decoration: none;
    color: black !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #1e88e5 !important;
    text-decoration: none;
}

a:active {
    color: black !important;
    text-decoration: none;
}

>>>.v-text-field.v-text-field--solo .v-input__control {
    min-height: 20px !important;
    padding: 0 !important;
}
>>> .v-text-field.v-text-field--solo .v-label {
    top: calc(50% - 10px) !important;
    font-size: 14px !important;
}
>>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: none !important;
    margin-bottom: 3px;
}
>>> .v-text-field.v-text-field--enclosed .v-input__slot {
    padding: 0px;
}
>>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea, .v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 25px;
  margin-top: 0;
  resize: none;
  font-size: 14px;
  padding-top: 0;
}
>>>.v-messages__message {
    line-height: normal !important;
}
>>> .v-text-field.v-text-field--enclosed .v-text-field__details {
    /* padding: 2px 0px; */
    padding-bottom: 2px;
    padding-left: 0px;
    padding-right: 0px;
}

>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea::placeholder {
  font-size: 14px !important;
  color: #757575 !important;
}

.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 90px !important;
  display: -webkit-inline-box !important;
  background: #2662af !important;
  padding-top: 3px !important;
  border-radius: 4px !important;
  margin-bottom: 15px !important;
}

>>>.theme--light.v-list .v-list__tile--link:hover {
    background: #2562af40 !important;
    /* color: white; */
}


</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/message/messageus.vue